'use client';

import { c as _c } from "react/compiler-runtime";
import type { ComponentPropsWithoutRef, ReactElement } from 'react';
import * as React from 'react';
import { IndexContext, useCarouselContext } from './context';
import { mergeProps, useMergedRef } from './utils';
export interface CarouselScrollerProps<T> extends Omit<ComponentPropsWithoutRef<'div'>, 'children'> {
  /**
   * The data with which each item should be derived.
   */
  items?: Array<T>;
  /**
   * The collection of carousel items.
   */
  children: ReactElement | ReactElement[] | ((item: T, index: number) => ReactElement);
}
function CarouselScrollerBase(t0, forwardedRef) {
  const $ = _c(15);
  const {
    children,
    items,
    ...props
  } = t0;
  const context = useCarouselContext();
  const {
    assignRef,
    carouselState
  } = context;
  const ref = useMergedRef(assignRef, forwardedRef);
  let t1;
  if ($[0] !== children || $[1] !== items) {
    t1 = typeof children === "function" ? items?.map(children) : children;
    $[0] = children;
    $[1] = items;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const kids = t1;
  let t2;
  if ($[3] !== kids) {
    t2 = function getChildren() {
      let kidsArr = React.Children.toArray(kids);
      if (kidsArr.length === 1 && kidsArr[0].type === React.Fragment) {
        kidsArr = React.Children.toArray(kidsArr[0].props.children);
      }
      return kidsArr;
    };
    $[3] = kids;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const getChildren = t2;
  const t3 = mergeProps(carouselState?.scrollerProps, props);
  const t4 = carouselState?.scrollerProps.style;
  const t5 = props?.style;
  let t6;
  if ($[5] !== t4 || $[6] !== t5) {
    t6 = {
      ...t4,
      ...t5
    };
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== getChildren) {
    t7 = getChildren().map(_temp);
    $[8] = getChildren;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== ref || $[11] !== t3 || $[12] !== t6 || $[13] !== t7) {
    t8 = <div ref={ref} {...t3} style={t6}>{t7}</div>;
    $[10] = ref;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}
function _temp(child, index) {
  return <IndexContext.Provider key={index} value={index}>{child}</IndexContext.Provider>;
}
export const CarouselScroller = React.forwardRef(CarouselScrollerBase) as <T>(props: CarouselScrollerProps<T> & {
  ref?: React.ForwardedRef<HTMLElement>;
}) => React.JSX.Element;